import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../../../theme/media';

import iconMozilla from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/mozilla.svg';
import iconCardAudio from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/card-audio.svg';
import iconCardVideo from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/card-video.svg';
import iconImage from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/image.svg';
import iconPrinter from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/printer.svg';
import iconDelete from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/delete.svg';
import iconIrl from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/irl.svg';
import iconWatch from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/watch.svg';
import iconBlog from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/blog.svg';
import iconPaste from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/paste.svg';
import iconPocket from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/pocket.svg';
import iconNotes from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/notes.svg';
import iconReleaseNotes from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/release-notes.svg';
import iconInbox from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/inbox.svg';
import iconPopupBlock from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/popup-block.svg';
import iconWindowNew from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/window-new.svg';
import iconFacebookContainer from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/facebook-container.svg';
import iconAddSearchEngine from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/add-search-engine.svg';
import iconExtensions from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/extensions.svg';
import iconDesktop from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/desktop.svg';
import iconPocketList from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/pocket-list.svg';
import iconSend from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/send.svg';
import iconListen from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/listen.svg';
import iconCommonVoice from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/common-voice.svg';
import iconAudio from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/audio.svg';
import iconAudioMute from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/audio-mute.svg';
import iconSendToDevice from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/send-to-device.svg';
import iconLabs from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/labs.svg';
import iconSecureMixed from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/secure-mixed.svg';
import iconExtensionsUpdate from '../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/extensions-update.svg';


const PaletteContainer = styled.div`
  width: fit-content;
  width: -moz-fit-content;
  ${media.phone`
    float: none;
  `}
  &.icon-card-audio button.icon-card-audio,
  &.icon-card-video button.icon-card-video,
  &.icon-mozilla button.icon-mozilla,
  &.icon-image button.icon-image,
  &.icon-printer button.icon-printer,
  &.icon-delete button.icon-delete,
  &.icon-irl button.icon-irl,
  &.icon-watch button.icon-watch,
  &.icon-blog button.icon-blog,
  &.icon-paste button.icon-paste,
  &.icon-pocket button.icon-pocket,
  &.icon-notes button.icon-notes,
  &.icon-release-notes button.icon-release-notes,
  &.icon-inbox button.icon-inbox,
  &.icon-popup-block button.icon-popup-block,
  &.icon-window-new button.icon-window-new,
  &.icon-facebook-container button.icon-facebook-container,
  &.icon-add-search-engine button.icon-add-search-engine,
  &.icon-extensions button.icon-extensions,
  &.icon-desktop button.icon-desktop,
  &.icon-pocket-list button.icon-pocket-list,
  &.icon-send button.icon-send,
  &.icon-listen button.icon-listen,
  &.icon-common-voice button.icon-common-voice,
  &.icon-audio button.icon-audio,
  &.icon-audio-mute button.icon-audio-mute,
  &.icon-send-to-device button.icon-send-to-device,
  &.icon-labs button.icon-labs,
  &.icon-secure-mixed button.icon-secure-mixed,
  &.icon-extensions-update button.icon-extensions-update {
      box-shadow: 0 0 0 6px white, 0 0 0 8px #F50900;
  }
`;

const PanelIcon = styled.button`
  background: white;
  display: inline-block;
  width: 32px;
  height: 32px;
  margin: 16px;
  border-radius: 100%;
  
  &.icon-mozilla { background-image: url(${iconMozilla})}
  &.icon-card-audio { background-image: url(${iconCardAudio})}
  &.icon-card-video { background-image: url(${iconCardVideo})}
  &.icon-image { background-image: url(${iconImage})}
  &.icon-printer { background-image: url(${iconPrinter})}
  &.icon-delete { background-image: url(${iconDelete})}
  &.icon-irl { background-image: url(${iconIrl})}
  &.icon-watch { background-image: url(${iconWatch})}
  &.icon-blog { background-image: url(${iconBlog})}
  &.icon-paste { background-image: url(${iconPaste})}
  &.icon-pocket { background-image: url(${iconPocket})}
  &.icon-notes { background-image: url(${iconNotes})}
  &.icon-release-notes { background-image: url(${iconReleaseNotes})}
  &.icon-inbox { background-image: url(${iconInbox})}
  &.icon-popup-block { background-image: url(${iconPopupBlock})}
  &.icon-window-new { background-image: url(${iconWindowNew})}
  &.icon-facebook-container { background-image: url(${iconFacebookContainer})}
  &.icon-add-search-engine { background-image: url(${iconAddSearchEngine})}
  &.icon-extensions { background-image: url(${iconExtensions})}
  &.icon-desktop { background-image: url(${iconDesktop})}
  &.icon-pocket-list { background-image: url(${iconPocketList})}
  &.icon-send { background-image: url(${iconSend})}
  &.icon-listen { background-image: url(${iconListen})}
  &.icon-common-voice { background-image: url(${iconCommonVoice})}
  &.icon-audio { background-image: url(${iconAudio})}
  &.icon-audio-mute { background-image: url(${iconAudioMute})}
  &.icon-send-to-device { background-image: url(${iconSendToDevice})}
  &.icon-labs { background-image: url(${iconLabs})}
  &.icon-secure-mixed { background-image: url(${iconSecureMixed})}
  &.icon-extensions-update { background-image: url(${iconExtensionsUpdate})}
  
  img {
    padding: 4px;
  }
  

  ${media.phone`
    width: 32px;
    height: 32px;
  `}
`;

const ContainerRight = styled.div`
  position: absolute;
  z-index: 99;
  right: 0;
  width: 50%;
  ${media.phone`
    width: 100%;
    max-width: 400px;
    margin: 0 auto 4rem auto;
    display: block;
    position: unset;
    order: 1;
  `}
`;

const ContainerLeft = styled.div`
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    position: absolute;
    z-index: 1;
    top: calc(50% - 48px);
  ${media.phone`
    width: 100%;
    max-width: 400px;
    margin: 0 auto 4rem auto;
    display: block;
    position: unset;
    order: 2;
  `}
`;

const Panel = styled.div`
    box-shadow: 0 16px 16px rgba(0,0,0,0.1);
    padding: 0;
    border: 1px solid #CFCCC9;
    border-radius: 10px;
    max-width: 360px;
    width: 100%;
    margin: 0 auto 2rem auto;
    
      /* Header */
    .header {
      background: #FAF8F6;
      border-bottom: 1px solid #CFCCC9;
      border-radius: 10px 10px 0 0;
    }
    .header-container {
      padding: 16px;
      align-items: center;
      display: flex;
    }
    .header-container-50 {
      width: 50%;
      line-height: 40px;
    }
    .header h2 {
      font-family: 'Source Serif Pro', serif;
      font-size: 24px;
      color: #1E1915;
      font-weight: 500;
      margin: 0;
    }

    .body-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        grid-gap: 1rem;
        margin: 32px 16px;
    }

    /* Score */
    @keyframes score {
      from, 70%, to {
        transform: scale(1, 1);
        }
      60% {
        transform: scale(0.975, 0.975);
      }
      80% {
        transform: scale(1.025, 1.025);
      }
    }

    #score {
        width: 40px;
        height: 40px;
        border-radius: 0;
        background: rgba(212,112,84,1);
        font-size: 22px;
        color: rgba(255, 255, 255, 1);
        transition: all 0.5s, color 0.25s;
        float: right;
    }
    #scoreLabel {
        width: 40px;
        line-height: 20px;
        display: block;
        vertical-align: middle;
        text-align: center;
        padding: 11px 0 9px 0;
        font-weight: 500;
        /* font-family: 'Proxima Nova', sans-serif; */
        font-size: 20px;
    }
    #score.circle {
        background-color: #409970;
        animation-name: score;
        animation-duration: 0.5s;
        animation-delay: 0.25s;
    }

    /* Body */
    .body {
      height: 565px;
      background: white;
      overflow: scroll;
    }
    h3 {
      color: #1E1915;
      /* font-family: "Proxima Nova", sans-serif; */
      font-size: 14px;
      line-height: 16px;
      text-transform: uppercase;
      font-weight: 500;
    }
    .card {
        display: flex;
        transition: all 0.25s;
        margin: 8px 0 0 0;
        padding: 4px 0;
        border-radius: 4px;
    }
    .card:hover {
        background: #F2F2F2;
        cursor: default;
    }
    .button-image {
        width: 16px;
        height: 16px;
        margin: 8px;
        background: #ABABB0;
        transition: all 0.25s;
        padding-right: 16px;
    }
    .button-image.pass, .button-image.success {
        background: rgba(64, 153, 112, 1);
        border-radius: 8px;
    }
    .button-image.fail, .button-image.error {
        background: rgba(212, 112, 84, 1);
        border-radius: 0;
    }
    .button-image.caution {
        background: rgba(240, 191, 110, 1);
        border-radius: 4px;
    }
    .button-title {
        padding: 0 8px;
    }
    .button-headline {
        color: #1E1915;
        /* font-family: "Proxima Nova", sans-serif; */
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
    }
    .button-note {
        display: block;
        color: #707070;
        /* font-family: "Proxima Nova", sans-serif; */
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
    }
    .section-body {
        margin-bottom: 16px;
    }
`;

const PanelHeader = styled.div`
  height: 32px;
  margin-bottom: 2rem;
  span {
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    color: #1E1F21;
  }
  svg {
    float: right;
  }
`;

const TextSample = styled.div`
    border: 1px solid #d2d2d2;
    position: relative;
    font-size: 23px;
    line-height: 32px;
    
    span {
      display: block;
    }
    
    span:first-letter {
        text-transform: uppercase;
    }
}
`;

const Corner1 = styled.div`
    border: 1px solid #d2d2d2;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    width: 8px;
    height: 8px;
    position: absolute;
    top: -4px;
    left: -4px;
`;

const Corner2 = styled.div`
    border: 1px solid #d2d2d2;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    width: 8px;
    height: 8px;
    position: absolute;
    top: -4px;
    left: 50%;
`;

const Corner3 = styled.div`
    border: 1px solid #d2d2d2;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    width: 8px;
    height: 8px;
    position: absolute;
    top: -4px;
    right: -4px;
`;

const Corner4 = styled.div`
    border: 1px solid #d2d2d2;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    width: 8px;
    height: 8px;
    position: absolute;
    bottom: -4px;
    left: -4px;
`;

const Corner5 = styled.div`
    border: 1px solid #d2d2d2;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    width: 8px;
    height: 8px;
    position: absolute;
    bottom: -4px;
    left: 50%;
`;

const Corner6 = styled.div`
    border: 1px solid #d2d2d2;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    width: 8px;
    height: 8px;
    position: absolute;
    bottom: -4px;
    right: -4px;
`;

const FlexContainer = styled.div`
    display: flex;
    height: 720px;
    ${media.phone`
      flex-wrap: wrap;
      height: auto;
    `}
`;

class ReviewPlugin extends Component {
  constructor() {
    super();
    
    this.fontSize = this.fontSize.bind(this);
    this.fontWeight = this.fontWeight.bind(this);
    this.lineHeight = this.lineHeight.bind(this);
    this.fontFamily = this.fontFamily.bind(this);
    this.contentWords = this.contentWords.bind(this);
    this.contentPhrases = this.contentPhrases.bind(this);
    this.tokens = this.tokens.bind(this);
    this.optimalLineLength = this.optimalLineLength.bind(this);
    this.spacingTop = this.spacingTop.bind(this);
    this.spacingLeft = this.spacingLeft.bind(this);
    
    this.state = {
      score: 0,
      color: '#C7755B',
      fontSize: '23px',
      fontWeight: '900',
      lineHeight: '40px',
      fontFamily: 'SF Pro Text',
      contentPhrases: 'You can click on',
      contentWords: 'Hi, ',
      tokens: '#000000',
      optimalLineLength: '100%',
      spacingTop: 13,
      spacingLeft: 17,
      enableFontSize: true,
      enableFontWeight: true,
      enableLineHeight: true,
      enableFontFamily: true,
      enableContentPhrases: true,
      enableContentWords: true,
      enableTokens: true,
      enableOptimalLineLength: true,
      enableSpacingTop: true,
      enableSpacingLeft: true,
      successFontSize: 'error',
      successFontWeight: 'error',
      successLineHeight: 'error',
      successFontFamily: 'error',
      successContentPhrases: 'error',
      successContentWords: 'error',
      successTokens: 'error',
      successOptimalLineLength: 'error',
      successSpacingTop: 'error',
      successSpacingLeft: 'error'
    }
  }
  
  fontSize() {
    if (this.state.enableFontSize == true) {
        this.setState({ fontSize: '24px' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableFontSize: false})
        this.setState({ successFontSize: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
    
  }
  fontWeight() {
    if (this.state.enableFontWeight == true) {
        this.setState({ fontWeight: '600' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableFontWeight: false})
        this.setState({ successFontWeight: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  lineHeight() {
    if (this.state.enableLineHeight == true) {
        this.setState({ lineHeight: '30px' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableLineHeight: false})
        this.setState({ successLineHeight: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  fontFamily() {
    if (this.state.enableFontFamily == true) {
        this.setState({ fontFamily: 'Source Serif Pro' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableFontFamily: false})
        this.setState({ successFontFamily: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  contentPhrases() {
    if (this.state.enableContentPhrases == true) {
        this.setState({ contentPhrases: 'use' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableContentPhrases: false})
        this.setState({ successContentPhrases: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  contentWords() {
    if (this.state.enableContentWords == true) {
        this.setState({ contentWords: '' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableContentWords: false})
        this.setState({ successContentWords: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  tokens() {
    if (this.state.enableTokens == true) {
        this.setState({ tokens: '' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableTokens: false})
        this.setState({ successTokens: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  optimalLineLength() {
    if (this.state.enableOptimalLineLength == true) {
        this.setState({ optimalLineLength: '360px' })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableOptimalLineLength: false})
        this.setState({ successOptimalLineLength: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  spacingTop() {
    if (this.state.enableSpacingTop == true) {
        this.setState({ spacingTop: 16 })
        this.setState({ score: this.state.score + 10})
        this.setState({ enableSpacingTop: false})
        this.setState({ successSpacingTop: 'success'})
        
        if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
        else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
        else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
        else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
        else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
        else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
        else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
        else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
        else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
        else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
    }
  }
  spacingLeft() {
      if (this.state.enableSpacingLeft == true) {
          this.setState({ spacingLeft: 16 })
          this.setState({ score: this.state.score + 10})
          this.setState({ enableSpacingLeft: false})
          this.setState({ successSpacingLeft: 'success'})
          
          if (this.state.score == 10) { this.setState({ color: '#ce8461' }) }
          else if (this.state.score == 20) { this.setState({ color: '#d59367' }) }
          else if (this.state.score == 30) { this.setState({ color: '#dba26e' }) }
          else if (this.state.score == 40) { this.setState({ color: '#e2b174' }) }
          else if (this.state.score == 50) { this.setState({ color: '#e9c071' }) }
          else if (this.state.score == 60) { this.setState({ color: '#ccb879' }) }
          else if (this.state.score == 70) { this.setState({ color: '#afb077' }) }
          else if (this.state.score == 80) { this.setState({ color: '#92a776' }) }
          else if (this.state.score == 90) { this.setState({ color: '#759f74' }) }
          else if (this.state.score == 100) { this.setState({ color: '#589773' }) }
      }
  }

  render() {
    return (
      <div>
        <FlexContainer>
          <ContainerLeft>
            <TextSample style={{width: this.state.optimalLineLength}}>
              <span style={{fontSize: this.state.fontSize, fontWeight: this.state.fontWeight, lineHeight: this.state.lineHeight, fontFamily: this.state.fontFamily, color: this.state.tokens}}>
                  {this.state.contentWords} {this.state.contentPhrases} the panel to update this text.
              </span>
              <Corner1/>
              <Corner2/>
              <Corner3/>
              <Corner4/>
              <Corner5/>
              <Corner6/>
            </TextSample>
            
          </ContainerLeft>
          <ContainerRight>
            <Panel>
                <div className="header">
                    <div className="header-container">
                        <div className="header-container-50">
                            <h2>Review</h2>
                        </div>
                        <div className="header-container-50">
                            {/* style="display: block; background-color: rgb(240, 191, 110); border-top-left-radius: 10px; border-top-right-radius: 10px; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;" */}
                            <div id="score" className="" style={{borderRadius: (this.state.score / 2) + '%', backgroundColor: this.state.color }}>
                                <span id="scoreLabel">{this.state.score}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body">
                    <div className="body-container">
                    
                        {/*}<!-- Layout -->*/}
                        <div id="review-layout" className="section"> {/* style="display: block;"> */}
                            <div className="section-header">
                                <h3>Layout</h3>
                            </div>
                            <div className="section-body">
                                {/*<!-- Optimal Line Length -->*/}
                                <div id="review-Accessibility-Width" className="card" onClick={this.optimalLineLength}> {/* style="display: flex;"> */}
                                    <div id="review-Accessibility-Width-image" className={'button-image ' + this.state.successOptimalLineLength}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Optimal Line Length</span>
                                        <span id="review-Accessibility-Width-note" className="button-note">192</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/*<!-- Style -->*/}
                        <div id="review-style" className="section"> {/* style="display: block;"> */}
                            <div className="section-header">
                                <h3>Type</h3>
                            </div>
                            <div className="section-body">
                                {/*<!-- Font Size -->*/}
                                <div id="review-Style-FontSize" className="card" onClick={this.fontSize}> {/* style="display: flex;"> */}
                                    <div id="review-Style-FontSize-image" className={'button-image ' + this.state.successFontSize}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Font Size</span>
                                        <span id="review-Style-FontSize-note" className="button-note">23 → 24</span>
                                    </div>
                                </div>
                                {/*<!-- Font Weight -->*/}
                                <div id="review-Style-FontWeight" className="card" onClick={this.fontWeight}> {/* style="display: flex;"> */}
                                    <div id="review-Style-FontWeight-image" className={'button-image ' + this.state.successFontWeight}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Font Weight</span>
                                        <span id="review-Style-FontWeight-note" className="button-note">Extrabold → Semibold</span>
                                    </div>
                                </div>
                                {/*<!-- Line Height -->*/}
                                <div id="review-Style-LineHeight" className="card" onClick={this.lineHeight}> {/* style="display: flex;"> */}
                                    <div id="review-Style-LineHeight-image" className={'button-image ' + this.state.successLineHeight}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Line Height</span>
                                        <span id="review-Style-LineHeight-note" className="button-note">40 → 30</span>
                                    </div>
                                </div>
                                {/*<!-- Typeface -->*/}
                                <div id="review-Style-Typeface" className="card" onClick={this.fontFamily}> {/* style="display: flex;"> */}
                                    <div id="review-Style-Typeface-image" className={'button-image ' + this.state.successFontFamily}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Typeface</span>
                                        <span id="review-Style-Typeface-note" className="button-note">SF Pro Text → Source Serif Pro</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/*<!-- Spacing -->*/}
                        <div id="review-content" className="section"> {/* style="display: block;"> */}
                            <div className="section-header">
                                <h3>Spacing</h3>
                            </div>
                            <div className="section-body">
                                {/*<!-- Top -->*/}
                                <div id="review-Spacing-Top" className="card" onClick={this.spacingTop}> {/* style="display: flex;"> */}
                                    <div id="review-Content-Phrases-image" className={'button-image ' + this.state.successSpacingTop}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Top</span>
                                        <span id="review-Content-Phrases-note" className="button-note">13</span>
                                    </div>
                                </div>
                                {/*<!-- Left -->*/}
                                <div id="review-Spacing-Left" className="card" onClick={this.spacingLeft}> {/* style="display: flex;"> */}
                                    <div id="review-Content-Words-image" className={'button-image ' + this.state.successSpacingLeft}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Left</span>
                                        <span id="review-Content-Words-note" className="button-note">17</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/*<!-- Content -->*/}
                        <div id="review-content" className="section"> {/* style="display: block;"> */}
                            <div className="section-header">
                                <h3>Content</h3>
                            </div>
                            <div className="section-body">
                                {/*<!-- Words -->*/}
                                <div id="review-Content-Words" className="card" onClick={this.contentWords}> {/* style="display: flex;"> */}
                                    <div id="review-Content-Words-image" className={'button-image ' + this.state.successContentWords}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Words</span>
                                        <span id="review-Content-Words-note" className="button-note">Hi → ''</span>
                                    </div>
                                </div>
                                {/*<!-- Phrases -->*/}
                                <div id="review-Content-Phrases" className="card" onClick={this.contentPhrases}> {/* style="display: flex;"> */}
                                    <div id="review-Content-Phrases-image" className={'button-image ' + this.state.successContentPhrases}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Phrases</span>
                                        <span id="review-Content-Phrases-note" className="button-note">You can click on → Use</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/*<!-- Color -->*/}
                        <div id="review-accessibility" className="section"> {/* style="display: block;"> */}
                            <div className="section-header">
                                <h3>Color</h3>
                            </div>
                            <div className="section-body">
                                
                                {/*<!-- Color (Tokens) -->*/}
                                <div id="review-Style-ColorTokens" className="card" onClick={this.tokens}> {/* style="display: flex;"> */}
                                    <div id="review-Style-ColorTokens-image" className={'button-image ' + this.state.successTokens}></div>
                                    <div className="button-title">
                                        <span className="button-headline">Tokens</span>
                                        <span id="review-Style-ColorTokens-note" className="button-note">#e1e1e1 → Smoke 8</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        
                        
                        
                    </div>
                </div>
            </Panel>
          </ContainerRight>
        </FlexContainer>
      </div>
    );
  }
}

export default ReviewPlugin;



// WEBPACK FOOTER //
// src/assets/Amazon/ReviewPlugin/ReviewPlugin.js